import React, {Component} from 'react'
import {Form, FormGroup, Label, Row, Col, Input, Collapse, Button, FormText} from 'reactstrap'
import {
    AvForm,
    AvField,
} from 'availity-reactstrap-validation'
import {Mutation} from 'react-apollo'
import {withRouter} from 'react-router-dom'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import _ from "lodash"
import moment from 'moment'

import mutation from '../../../queries/server/mutations/create_user'

import AUSelectGenerator from '../../components/auto_updaters/ValidSelect'

const AUSelectOffice = AUSelectGenerator('offices', 'id description', 'id', ['description'])
const AUSelectUserRoles = AUSelectGenerator('user_roles', 'user_role_id description', 'user_role_id', ['description'])
const AUSelectUsers = AUSelectGenerator('users', 'user_id first_name last_name', 'user_id', ['first_name', 'last_name'])

class CreateUserForm extends Component {

    constructor(props) {
        super(props)

        this.state = {
            first_name: '',
            last_name: '',
            email: '',
            user_role_id: null,
            standard_hours_work_per_week: 37.5,
            line_manager_user_id: null,
            office_id: null,
            username: '',
            password: '',
            standard_hours_leave_allowance: 20,
            mobile: '',
            phone_number: '',
            timesheet_entry_required: true,
            display_in_scheduler: true,
            annual_leave_rollover_days: 5,
            date_created: moment().format('YYYY-MM-DD')
        }

        this.save = _.debounce(this.save, 1000)
    }

    save = (mutationFunc) => {

        const {
            first_name,
            last_name,
            email,
            user_role_id,
            standard_hours_work_per_week,
            active,
            line_manager_user_id,
            office_id,
            username,
            password,
            standard_hours_leave_allowance,
            mobile,
            phone_number,
            timesheet_entry_required,
            display_in_scheduler,
            annual_leave_rollover_days,
            date_created,
        } = this.state

        mutationFunc({
            variables: {
                data: {
                    first_name,
                    last_name,
                    email,
                    user_role_id,
                    standard_hours_work_per_week,
                    active,
                    line_manager_user_id,
                    office_id,
                    standard_hours_leave_allowance,
                    mobile,
                    phone_number,
                    timesheet_entry_required,
                    display_in_scheduler,
                    username,
                    password,
                    annual_leave_rollover_days,
                    date_created,
                }
            }
        })
            .then(({data}) => {
                this.props.history.replace(`/users/${data.createUser.user_id}`)
            })
    }

    render() {

        const {
            first_name,
            last_name,
            email,
            user_role_id,
            standard_hours_work_per_week,
            line_manager_user_id,
            office_id,
            username,
            password,
            standard_hours_leave_allowance,
            mobile,
            phone_number,
            timesheet_entry_required,
            display_in_scheduler,
            annual_leave_rollover_days,
            date_created,
        } = this.state

        return (
            <Mutation mutation={mutation}>
                {(createUserDetailsFunc, {loading}) => (
                    <AvForm
                        autoComplete="off"
                        onValidSubmit={() => {
                            this.save(createUserDetailsFunc)
                        }}
                    >
                        <Row form>
                            <Col>
                                <AvField
                                    label="First Name*"
                                    name="first_name"
                                    id="first_name"
                                    bsSize="sm"
                                    required
                                    errorMessage="Required"
                                    value={first_name}
                                    onChange={(evt) => {
                                        this.setState({first_name: evt.target.value})
                                    }}
                                />
                            </Col>
                            <Col>
                                <AvField
                                    required
                                    errorMessage="Required"
                                    label="Last Name*"
                                    type="text"
                                    name="last_name"
                                    id="last_name"
                                    className="form-control-sm"
                                    value={last_name}
                                    onChange={(evt) => {
                                        const last_name = evt.target.value
                                        this.setState({last_name})
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row form>
                            <Col>
                                <AvField
                                    required
                                    errorMessage="Required"
                                    label="Username*"
                                    type="text"
                                    name="username"
                                    id="username"
                                    className="form-control-sm"
                                    autoComplete="off"
                                    value={username}
                                    onChange={(evt) => {
                                        const username = evt.target.value
                                        this.setState({username})
                                    }}
                                />
                            </Col>
                            <Col>
                                <AvField
                                    required
                                    errorMessage="Required"
                                    label="Password*"
                                    type="password"
                                    name="password"
                                    id="password"
                                    className="form-control-sm"
                                    autoComplete="off"
                                    value={password}
                                    onChange={(evt) => {
                                        const password = evt.target.value
                                        this.setState({password})
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row form>
                            <Col>
                                <AUSelectUserRoles
                                    required
                                    errorMessage="Required"
                                    label="Role*"
                                    name="user_role"
                                    id="user_role"
                                    className="form-control-sm"
                                    value={user_role_id}
                                    onChange={(value) => {
                                        const user_role_id = value
                                        this.setState({user_role_id})
                                    }}
                                />
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="line_manager_user_id" className="m-0">Line Manager</Label>
                                    <AUSelectUsers
                                        name="line_manager_user_id"
                                        id="line_manager_user_id"
                                        className="form-control-sm"
                                        value={line_manager_user_id}
                                        onChange={(value) => {
                                            const line_manager_user_id = value
                                            this.setState({line_manager_user_id})
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                            <Col>
                                    <AUSelectOffice
                                        required
                                        errorMessage="Required"
                                        label="Office*"
                                        name="office_id"
                                        id="office_id"
                                        className="form-control-sm"
                                        value={office_id}
                                        onChange={(value) => {
                                            const office_id = value
                                            this.setState({office_id})
                                        }}
                                    />
                            </Col>

                        </Row>
                        <Row form>
                            <Col>
                                <FormGroup>
                                    <Label for="name" className="m-0">Email</Label>
                                    <Input
                                        type="email"
                                        name="email"
                                        id="email"
                                        className="form-control-sm"
                                        value={email}
                                        onChange={(evt) => {
                                            const email = evt.target.value
                                            this.setState({email})
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label className="m-0">Mobile</Label>
                                    <Input
                                        type="text"
                                        name="mobile"
                                        id="mobile"
                                        className="form-control-sm"
                                        value={mobile}
                                        onChange={(evt) => {
                                            const mobile = evt.target.value
                                            this.setState({mobile})
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label className="m-0">Landline</Label>
                                    <Input
                                        type="text"
                                        name="phone_number"
                                        id="phone_number"
                                        className="form-control-sm"
                                        value={phone_number}
                                        onChange={(evt) => {
                                            const phone_number = evt.target.value
                                            this.setState({phone_number})
                                        }}
                                    />
                                </FormGroup>
                            </Col>

                        </Row>
                        <Row form>
                            <Col>
                                <FormGroup>
                                    <Label className="m-0">Start Date</Label>
                                    <Input
                                        type="date"
                                        name="start_date"
                                        id="start_date"
                                        className="form-control-sm"
                                        value={date_created}
                                        onChange={(evt) => {
                                            const date_created = evt.target.value
                                            this.setState({date_created})
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                            <Col>
                                    <AvField
                                        required
                                        errorMessage="Required"
                                        label="Hours Work Per Week*"
                                        type="number"
                                        name="hours_worked"
                                        id="hours_worked"
                                        className="form-control-sm"
                                        value={standard_hours_work_per_week}
                                        onChange={(evt) => {
                                            const standard_hours_work_per_week = evt.target.value
                                            this.setState({standard_hours_work_per_week})
                                        }}
                                    />
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label className="m-0">Yearly Annual Leave (Days)</Label>
                                    <Input
                                        type="number"
                                        name="annual_leave"
                                        id="annual_leave"
                                        className="form-control-sm"
                                        value={standard_hours_leave_allowance}
                                        onChange={(evt) => {
                                            const standard_hours_leave_allowance = evt.target.value
                                            this.setState({standard_hours_leave_allowance})
                                        }}
                                    />
                                    <FormText color="muted">
                                    Please enter the annual leave for the year. The system will prorate for you.
                                    </FormText>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label className="m-0">Annual Leave Rollover (Days)</Label>
                                    <Input
                                        type="number"
                                        name="annual_leave_roll"
                                        id="annual_leave_roll"
                                        className="form-control-sm"
                                        value={annual_leave_rollover_days}
                                        onChange={(evt) => {
                                            const annual_leave_rollover_days = evt.target.value
                                            this.setState({annual_leave_rollover_days})
                                        }}
                                    />
                                    <FormText color="muted">
                                    This is the max number of days that the user can roll over to the next year.
                                    </FormText>
                                </FormGroup>
                            </Col>

                        </Row>

                        
                        <Row form>
                            <Col>
                                <FormGroup check>
                                    <Label check>
                                        <Input
                                            type="checkbox"
                                            checked={timesheet_entry_required}
                                            onChange={(evt) => {
                                                const timesheet_entry_required = evt.target.checked
                                                this.setState({timesheet_entry_required})
                                            }}
                                        />{' '}
                                        Timesheet Entry Required
                                    </Label>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row form>
                            <Col>
                                <FormGroup check>
                                    <Label check>
                                        <Input
                                            type="checkbox"
                                            checked={display_in_scheduler}
                                            onChange={(evt) => {
                                                const display_in_scheduler = evt.target.checked
                                                this.setState({display_in_scheduler})
                                            }}
                                        />{' '}
                                        In Scheduler
                                    </Label>
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="d-flex justify-content-end align-content-end" style={{flex: 1}}>
                            <Button
                                size="sm"
                                color="success"
                                disabled={loading}
                            >
                                <FontAwesomeIcon
                                    color="#fff"
                                    icon={loading ? 'spinner' : 'save'}
                                    spin={loading}
                                />{' '}
                                {loading ? 'Saving...' : 'Save User'}
                            </Button>
                        </div>

                    </AvForm>

                )}

            </Mutation>
        )
    }

}

export default withRouter(CreateUserForm)